module.exports = __webpack_public_path__ + "img/SketchPng4536bee7216fd52e3d7f2aebb9fa76dd8da733b83a49ab7111d58babbae5e8bd.44b8879c.png";